import * as THREE from 'three';
import { PullDirection } from '../../../models/pull-direction.model';

const SUGGESTION_ARROW_COLOR = 0x000000;
const SELECTED_ARROW_COLOR = 0x00cc00;

export function renderPullDirectionArrows(
  arrowGroup: THREE.Group,
  objectGroup: THREE.Group,
  pullDirections: PullDirection[],
  selectedPullDirection: PullDirection | null = null,
): void {
  arrowGroup.clear();

  const box = new THREE.Box3().setFromObject(objectGroup);
  if (box.isEmpty()) return;

  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());
  const arrowLength = Math.max(size.x, size.y, size.z) * 0.6;

  // Draw all suggested pull directions in black.
  for (const dir of pullDirections) {
    const direction = new THREE.Vector3(dir.x, dir.y, dir.z).normalize();
    const arrow = new THREE.ArrowHelper(
      direction,
      center,
      arrowLength,
      SUGGESTION_ARROW_COLOR,
      arrowLength * 0.2,
      arrowLength * 0.08,
    );
    arrowGroup.add(arrow);
  }

  // Draw the selected pull direction in green (may or may not be a suggestion).
  if (selectedPullDirection) {
    const direction = new THREE.Vector3(
      selectedPullDirection.x,
      selectedPullDirection.y,
      selectedPullDirection.z,
    ).normalize();
    const arrow = new THREE.ArrowHelper(
      direction,
      center,
      arrowLength,
      SELECTED_ARROW_COLOR,
      arrowLength * 0.2,
      arrowLength * 0.08,
    );
    arrowGroup.add(arrow);
  }
}
